<template>
    <div class="mt-16 px-6 h-full flex flex-col">
        <h2 class="text-2xl font-bold">{{ t('phone_header') }}</h2>
        <div class=" max-w-lg mx-auto w-full pt-4 pb-6">
            <p class="text-base font-bold">{{ t('type_number') }}</p>
            <InputsPhoneInput @update:modelValue="val => updatePhone(val)" class="mt-2"></InputsPhoneInput>
            <Button @click="sendCode()" class="mt-2 text" :class="{' opacity-50 pointer-events-none' : phone == ''}" :loading="loading" :text="t('receive_code')" type="step" ></Button>
        </div>
    </div>
</template>

<script setup lang="ts">
    const { t } = useI18n()
    const emit = defineEmits(["update:modelValue"]);
    const props = defineProps<{
        loading: boolean;
    }>()
    const phone = ref('');
    function updatePhone(val: { phone: string }) {
        phone.value = val.phone
    };
    function sendCode() {
        emit("update:modelValue", {
            phone: phone.value
        });
    };
</script>